import { useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { useAppSelector } from '@/store/hooks';
import { useJourneyNavigate } from '@/services/journeys/useJourneyNavigate';
import Loader from '@/components/loader/Loader';
import { useLoadTransaction } from './useLoadTransaction';

function DirectPaymentInit() {
  const { transactionId } = useParams();
  const currentJourney = useAppSelector(state => state.journeys.journey);

  const journeyNavigate = useJourneyNavigate('init');

  const loadTransaction = useLoadTransaction();

  useEffect(() => {
    async function triggerLoadTransaction() {
      // Wait until both transactionId and correct journey are available. Without the currentJourney check, you can end up seeing the console
      // error "Error: Path "init" does not exist in journey" if you're using the direct journey.
      if (!transactionId || currentJourney !== 'direct') {
        return;
      }

      // Verify the (pending) transaction exists and load the data into relevant states
      const transactionExists = await loadTransaction(transactionId);

      if (!transactionExists) {
        // If a *pending* transaction *does not* exist, redirect to not-found
        journeyNavigate('not-found');
        return;
      }

      // If the transaction *does* exist, redirect to payment-select
      journeyNavigate('payment-select');
    }

    void triggerLoadTransaction();
  }, [transactionId, currentJourney, loadTransaction, journeyNavigate]);

  return (
    <Loader />
  );
}

export default DirectPaymentInit;
